import * as THREE from 'three';

// 形状定义
// const shapes = {
//     sphere: (nodeSize) => new THREE.SphereGeometry(nodeSize),
//     cube: (nodeSize) => new THREE.TetrahedronGeometry(nodeSize * 0.9, 0),
//     // 以后要添加新形状时在这里添加, 例如:
//     cylinder: (nodeSize) => new THREE.CylinderGeometry(
//         nodeSize * 0.6,  // 顶部半径
//         nodeSize * 0.6,  // 底部半径
//         nodeSize * 1.2,  // 高度
//         4,             // radialSegments: 圆周分段数，决定了圆周上的边数，比如改成 8 会更棱角分明
//         1,              // heightSegments: 高度分段数
//         false           // openEnded: 是否开放端面
//     )
// };
const shapes = {
    sphere: (nodeSize) => new THREE.SphereGeometry(nodeSize * 1), // 球体
    cube: (nodeSize) => new THREE.TetrahedronGeometry(nodeSize * 1.6, 0), // 四面体（原立方体替代方案）

    // 已定义的12种新形状：
    cylinder: (nodeSize) => new THREE.CylinderGeometry(
        nodeSize * 0.6,  // 顶部半径
        nodeSize * 0.6,  // 底部半径
        nodeSize * 1.2,  // 高度
        12,              // 圆周分段数（更高值更平滑）
        1                // 高度分段数
    ),

    cone: (nodeSize) => new THREE.ConeGeometry(
        nodeSize * 1,  // 底部半径
        nodeSize * 2,  // 高度
        8                // 径向分段数
    ),

    torus: (nodeSize) => new THREE.TorusGeometry(
        nodeSize,        // 环面半径
        nodeSize * 0.4,  // 管道半径
        8,               // 径向分段数
        6                //  tubular分段数
    ),

    octahedron: (nodeSize) => new THREE.OctahedronGeometry(
        nodeSize,        // 半径
        0                // 细节级别（0=最低细节）
    ),

    dodecahedron: (nodeSize) => new THREE.DodecahedronGeometry(
        nodeSize * 1,  // 半径
        0                // 细节级别
    ),

    icosahedron: (nodeSize) => new THREE.IcosahedronGeometry(
        nodeSize * 1.2,        // 半径
        1                // 细节级别（1=中等细节）
    ),

    tetrahedron: (nodeSize) => new THREE.TetrahedronGeometry(
        nodeSize  * 0.9,        // 半径
        0                // 细节级别
    ),

    ring: (nodeSize) => new THREE.RingGeometry(
        nodeSize * 0.4,  // 内半径
        nodeSize,        // 外半径
        8                // θ分段数
    ),

    plane: (nodeSize) => new THREE.PlaneGeometry(
        nodeSize * 1.5,  // 宽度
        nodeSize * 1.5   // 高度
    ),

    capsule: (nodeSize) => new THREE.CapsuleGeometry(
        nodeSize * 0.5,  // 半径
        nodeSize,        // 长度
        4,               // 帽分段数
        8                // 径向分段数
    ),

    prism: (nodeSize) => new THREE.CylinderGeometry(
        nodeSize * 0.5,  // 顶部半径
        nodeSize * 0.5,  // 底部半径
        nodeSize * 1.2,  // 高度
        3                // 侧面数（3=三棱柱）
    ),

    star: (nodeSize) => { // 通过挤出形状创建星形
        const starShape = new THREE.Shape();
        const spikes = 5;
        const outerRadius = nodeSize;
        const innerRadius = nodeSize * 0.4;

        for (let i = 0; i < spikes * 2; i++) {
            const radius = i % 2 === 0 ? outerRadius : innerRadius;
            const angle = (i * Math.PI) / spikes;
            starShape.lineTo(
                Math.cos(angle) * radius,
                Math.sin(angle) * radius
            );
        }

        return new THREE.ExtrudeGeometry(starShape, {
            depth: nodeSize * 0.3,
            bevelEnabled: false
        });
    }
};

// 3.2 颜色和形状映射, 决定categoryInfo中某类别的颜色和形状, 像类似ACTI这种缩写, 只是为了做预留, 暂时没有真正发挥用处
// Light blue: #87CEEB, Light purple: #D8BFD8, Mint green: #B2FFFC, Light pink: #FFB6C1, 
// Light yellow: #FFFF99, Light gray: #D3D3D3, Light green: #90EE90, Light orange: #F0E68C, 
// Light purple (pinkish): #E6E6FA, Light cyan: #B0E0E6
// export const colorMap = new Map([
//     ["CUI",  "#A822A1"],       
//     ["RXNORM","#187A1A"],      
//     ["PheCode",  "#441DF0"],   
//     ["PheCode",  "#00C6F2"],   
//     ["CCS", "#D74D00"],        
//     ["environmental information processing",  "#2DAACC"], 
//     ["genetic information processing",  "#A822A1"], 
//     ["human diseases",  "#187A1A"],                 
//     ["intergenic",  "#002FA7"],                     
//     ["metabolism",  "#652C97"],                     
//     ["non coding RNA",  "#F20C51"],                 
//     ["organismal systems",  "#FFCF14"],             
//     ["other gene",  "#D74D00"],                     
//     ["other protein coding gene",  "#A5FFD6"],      
//     ["signaling and cellular processes",  "#E09CFF"],
//     ["colorgroup", "#076c07"],
//     ["Other", "white"]                                   
// ]); 
export const colorMap = new Map([
    // CUI
    // ["ACTI",  "#e879f9"],
    // ["CHEM",  "#d946ef"],
    // ["DISO",  "#c026d3"],
    // ["PHEN",  "#a21caf"],
    // ["PHYS",  "#86198f"],
    // ["PROC",  "#701a75"],
    // ["Other CUI",  "#4a044e"],
    //
    // // Phenotyoe
    // ["RXNORM","#187A1A"],
    // ["PheCode",  "#441DF0"],
    // ["CCS", "#D74D00"],
    // ["LOINC","#002FA7"],
    // ["Other lab",  "#FFCF14"],
    // ["ShortName",  "#00C6F2"],

    ["Disease Codified",  "#002FA7"],
    ["Disease NLP",  "#1f78b4"],
    ["Drug Codified",  "#b2df8a"],
    ["Drug NLP",  "#33a02c"],
    ["Lab Codified",  "#D74D00"],
    ["Lab NLP",  "#e31a1c"],
    ["Procedure Codified",  "#A822A1"],
    ["Procedure NLP",  "#652C97"],
    ["Other NLP",  "#fb9a99"],

    // Gene
    ["environmental information processing",  "#D74D00"],
    ["genetic information processing",  "#A822A1"],
    ["human diseases",  "#187A1A"],
    ["metabolism",  "#F20C51"],
    ["organismal systems",  "#FFCF14"],
    ["signaling and cellular processes",  "#002FA7"],
    ["intergenic",  "#780078"],
    ["non coding RNA",  "#998297"],
    ["other gene",  "#5F7099"],

    // Extra
    ["colorgroup", "#076c07"],
    ["Other", "white"]                                          
]);



// 形状映射表, type作为形状的类型, "Phenotype = cube 三角形", "Variation = sphere 球体"
// export const shapeMap = new Map([
//     ["CUI",  "cube"],
//     ["RXNORM","cube"],
//     ["PheCode",  "cube"],
//     ["CCS", "cube"],
//     ["environmental information processing",  "sphere"],
//     ["genetic information processing",  "sphere"],
//     ["human diseases",  "sphere"],
//     ["intergenic",  "sphere"],
//     ["metabolism",  "sphere"],
//     ["non coding RNA",  "sphere"],
//     ["organismal systems",  "sphere"],
//     ["other gene",  "sphere"],
//     ["other protein coding gene",  "sphere"],
//     ["signaling and cellular processes",  "sphere"],
//     ["colorgroup",  "cylinder"],
//     ["Other", "sphere"]
// ]);
export const shapeMap = new Map([
    ["Disease Codified",  "cube"],
    ["Disease NLP",  "cube"],
    ["Drug Codified",  "cube"],
    ["Drug NLP",  "cube"],
    ["Lab Codified",  "cube"],
    ["Lab NLP",  "cube"],
    ["Procedure Codified",  "cube"],
    ["Procedure NLP",  "cube"],
    ["Other NLP",  "cube"],

    // Genotype
    ["environmental information processing",  "sphere"],
    ["genetic information processing",  "sphere"],
    ["human diseases",  "sphere"],
    ["metabolism",  "sphere"],
    ["organismal systems",  "sphere"],
    ["signaling and cellular processes",  "sphere"],
    ["intergenic",  "sphere"],
    ["non coding RNA",  "sphere"],
    ["other gene",  "sphere"],

    ["Other", "sphere"]
]);

// 创建几何体的函数
export function createNodeGeometry(shape, nodeSize) {
    const shapeType = shape || 'sphere';
    const createShape = shapes[shapeType];
    
    if (!createShape) {
        console.warn(`Shape type "${shape}" not found, using sphere`);
        return shapes.sphere(nodeSize);
    }
    return createShape(nodeSize);
}
